import { pages } from "@/services/requests";
import { useMutation } from "react-query";

function userOrderFollow() {
  const {
    data,
    mutate: mutateOrderFollow,
    isLoading,
    isSuccess,
    isError,
    isIdle
  } = useMutation((params: { id: string }) => pages.orderFollow(params));

  return {
    data,
    mutateOrderFollow,
    isLoading,
    isSuccess,
    isError,
    isIdle
  };
}

export default userOrderFollow;
